import IBusiness from '@/models/interfaces/IBusiness';
import Business from '@/models/business/Business';
import IBusinessState from './interfaces/business-state.d';

export default class BusinessState implements IBusinessState {
    public business: IBusiness = new Business();
}
